import { useEffect, useState } from 'react'
import { NavLink, Link } from 'react-router-dom'

import { nav } from '../nav'
import { OPEN_SEARCH_EVENT } from './SearchModal'

interface Props {
  /** Only meaningful on mobile, where the sidebar is an off-canvas drawer. */
  open: boolean
  /** Called when a nav link is clicked, so mobile callers can close the drawer. */
  onNavigate: () => void
}

export default function Sidebar({ open, onNavigate }: Props) {
  // Server-render the Windows hint, then correct it on the client. The first
  // client render matches the server, so there's no hydration mismatch.
  const [isMac, setIsMac] = useState(false)
  useEffect(() => {
    setIsMac(/Mac|iP(hone|ad|od)/.test(navigator.platform))
  }, [])

  return (
    <aside
      className={open ? 'help-sidebar is-open' : 'help-sidebar'}
      aria-label="Documentation navigation"
    >
      <div className="brand">
        <span className="brand-dot" aria-hidden />
        <Link to="/" onClick={onNavigate}>
          Chosen Help
        </Link>
      </div>

      <button
        type="button"
        className="search-trigger"
        onClick={() => {
          onNavigate()
          window.dispatchEvent(new Event(OPEN_SEARCH_EVENT))
        }}
      >
        <span>Search the docs</span>
        <kbd>{isMac ? '⌘' : 'Ctrl'} K</kbd>
      </button>

      <nav>
        {nav.map((section) => (
          <div key={section.title} className="nav-group">
            <p className="nav-group-title">{section.title}</p>
            {section.items.map((node) => (
              <div key={node.slug} className="nav-node">
                <NavLink
                  to={node.slug}
                  end
                  onClick={onNavigate}
                  className={({ isActive }) =>
                    isActive ? 'nav-link active' : 'nav-link'
                  }
                >
                  {node.title}
                </NavLink>
                {node.children.length > 0 && (
                  <div className="nav-children">
                    {node.children.map((child) => (
                      <NavLink
                        key={child.slug}
                        to={child.slug}
                        onClick={onNavigate}
                        className={({ isActive }) =>
                          isActive
                            ? 'nav-link nav-child active'
                            : 'nav-link nav-child'
                        }
                      >
                        {child.title}
                      </NavLink>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        ))}
      </nav>

      <div className="sidebar-footer">
        <a href="https://hire.chosenhq.com">Open Chosen ↗</a>
        <a href="https://developers.chosenhq.com">API docs ↗</a>
      </div>
    </aside>
  )
}
